import { useEffect } from 'react';
import { Checkbox } from '@tiendanube/components';
import useCancelInvoiceOnOrderCancel from 'domains/Orders/Orders/hooks/useCancelInvoiceOnOrderCancel';

interface Props {
  readonly label: string;
  readonly orderId: string;
  readonly fulfillmentOrderId: string;
  readonly cancelReason: string;
  readonly onReady: (options: {
    canCancelInvoice: boolean;
    cancelInvoice: (() => Promise<boolean>) | null;
  }) => void;
}

function CheckboxCancelInvoice({
  label,
  orderId,
  fulfillmentOrderId,
  cancelReason,
  onReady,
}: Props) {
  const { canCancelInvoice, cancelInvoice, currentInvoice } =
    useCancelInvoiceOnOrderCancel({ orderId, fulfillmentOrderId });

  useEffect(() => {
    onReady({
      canCancelInvoice,
      cancelInvoice: canCancelInvoice
        ? () => cancelInvoice(cancelReason)
        : null,
    });
  }, [canCancelInvoice, cancelInvoice, cancelReason, onReady]);

  if (!canCancelInvoice) return null;

  return (
    <Checkbox
      label={label + ' #' + (currentInvoice?.invoice_number ?? '')}
      name="cancel_invoice"
      checked
      disabled
    />
  );
}

export default CheckboxCancelInvoice;
